<div class="field-dialog">
  <mat-toolbar class="field-dialog__header">
    <div class="field-dialog__header__title">
      <h2 class="field-dialog__header__title__text">
        <ng-container *ngIf="isOnEditDialog">{{ 'DIALOG_EDIT_CRITERIAS_GROUP.EDIT_TITLE' | translate }}</ng-container>
        <ng-container *ngIf="!isOnEditDialog">{{
          'DIALOG_EDIT_CRITERIAS_GROUP.CREATE_TITLE' | translate
        }}</ng-container>
      </h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon class="field-dialog__header__close__icon">close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      class="field-dialog__content__scroll"
      name="form"
      [formGroup]="criteriasGroupForm"
      *ngIf="criteriasGroupForm"
      fusePerfectScrollbar
    >
      <div class="field-dialog__content__scroll__forms field-outline-form">
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'DIALOG_EDIT_CRITERIAS_GROUP.NAME' | translate }}
          </mat-label>
          <input required type="text" matInput formControlName="name" (keydown.enter)="$event.preventDefault()" />
          <mat-error *ngIf="criteriasGroupForm.get('name').hasError('required')">
            {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.NAME_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="criteriasGroupForm.get('name').hasError('maxlength')">
            {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.NAME_MAX_LENGTH' | translate }}
          </mat-error>
        </mat-form-field>

        <span class="field-dialog__content__scroll__forms__description">
          {{ 'DIALOG_EDIT_CRITERIAS_GROUP.DESCRIPTION' | translate }}
        </span>

        <div class="field-dialog__content__scroll__forms__criterias">
          <div
            *ngFor="let criteriaFormGroup of criteriasGroupForm.get('criterias').controls; let i = index"
            class="field-dialog__content__scroll__forms__criterias__criteria"
            [formGroup]="criteriaFormGroup"
          >
            <div
              [ngClass]="{ 'all-rounded': criteriaFormGroup.get('ruleName').value === null }"
              class="field-dialog__content__scroll__forms__criterias__criteria__header"
            >
              <span class="field-dialog__content__scroll__forms__criterias__criteria__header__index">
                {{ i + 1 }}.
              </span>
              <div class="field-dialog__content__scroll__forms__criterias__criteria__header__select">
                <fc-outlined-select
                  style="width: 400px"
                  [control]="criteriaFormGroup.get('ruleName')"
                  (select)="handleRuleChange()"
                  [label]="'DIALOG_EDIT_CRITERIAS_GROUP.SELECT' | translate"
                  [predefinedOptions]="criteriaRules"
                >
                </fc-outlined-select>

                <fc-maintenance-types-input
                  style="width: 200px"
                  *ngIf="criteriaFormGroup.get('maintenanceTypes')"
                  [control]="criteriaFormGroup.get('maintenanceTypes')"
                ></fc-maintenance-types-input>
              </div>
              <ng-container *ngIf="criteriasGroupForm.get('criterias').controls.length > 1">
                <mat-icon
                  [matTooltip]="'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.DELETE_CRITERIA' | translate"
                  (click)="removeCriteria(criteriaFormGroup)"
                  class="field-dialog__content__scroll__forms__criterias__criteria__header__delete"
                >
                  delete
                </mat-icon>
              </ng-container>
            </div>
            <div
              *ngIf="criteriaFormGroup.get('ruleName').value"
              class="field-dialog__content__scroll__forms__criterias__criteria__content"
            >
              <ng-container *ngIf="isPercentageGreaterBetter.includes(criteriaFormGroup.get('ruleName').value)">
                <div class="field-dialog__content__scroll__forms__criterias__criteria__content__input">
                  <span
                    [innerHTML]="'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.PERCENTAGE_GREATER_BETTER.TEXT' | translate"
                  ></span>
                  <div class="input-block-with-validation">
                    <input
                      type="number"
                      [formControl]="criteriaFormGroup.get('value').get('points')"
                      [value]="criteriaFormGroup.get('value').get('points').value"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                    />
                    <mat-error *ngIf="criteriaFormGroup.get('value').get('points').hasError('max')">
                      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.MAX_VALUE' | translate }}
                    </mat-error>
                  </div>
                  <span>{{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.POINTS' | translate }}</span>
                </div>
                <span class="field-dialog__content__scroll__forms__criterias__criteria__content__description">
                  {{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.PERCENTAGE_GREATER_BETTER.DESCRIPTION' | translate }}
                </span>
              </ng-container>

              <ng-container *ngIf="isPercentageLowerBetter.includes(criteriaFormGroup.get('ruleName').value)">
                <div class="field-dialog__content__scroll__forms__criterias__criteria__content__input">
                  <span
                    [innerHTML]="'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.PERCENTAGE_LOWER_BETTER.TEXT' | translate"
                  ></span>
                  <div class="input-block-with-validation">
                    <input
                      type="number"
                      [formControl]="criteriaFormGroup.get('value').get('points')"
                      [value]="criteriaFormGroup.get('value').get('points').value"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                    />
                    <mat-error *ngIf="criteriaFormGroup.get('value').get('points').hasError('max')">
                      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.MAX_VALUE' | translate }}
                    </mat-error>
                  </div>
                  <span>{{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.POINTS' | translate }}</span>
                </div>
                <span class="field-dialog__content__scroll__forms__criterias__criteria__content__description">
                  {{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.PERCENTAGE_LOWER_BETTER.DESCRIPTION' | translate }}
                </span>
              </ng-container>

              <ng-container *ngIf="typesByRange.includes(criteriaFormGroup.get('ruleName').value)">
                <div
                  [ngClass]="{ 'error-border': range.getError('rangeConflict') }"
                  *ngFor="let range of criteriaFormGroup.get('value').get('percentRange')?.controls; let j = index"
                  class="field-dialog__content__scroll__forms__criterias__criteria__content__sub-content"
                >
                  <div class="field-dialog__content__scroll__forms__criterias__criteria__content__sub-content__title">
                    <span class="bold"> {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RULES' | translate }} #{{ j + 1 }} </span>
                  </div>
                  <div class="flex items-center">
                    <div
                      [formGroup]="range"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__sub-content__inputs"
                    >
                      <span>
                        {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RANGES.TEXT_1' | translate }}
                      </span>

                      <input
                        required
                        formControlName="start"
                        type="number"
                        [value]="range?.get('start')?.value"
                        class="h-36 field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                        [ngClass]="{ 'error-border': hasError(range.get('start')) }"
                        (input)="range.get('start').setValue($event.target.value)"
                      />

                      <span>
                        {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RANGES.TEXT_2' | translate }}
                      </span>

                      <input
                        required
                        type="number"
                        [formControl]="range?.get('end')"
                        [value]="range?.get('end').value"
                        [ngClass]="{ 'error-border': hasError(range.get('end')) }"
                        class="h-36 field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                        (input)="range.get('end').setValue($event.target.value)"
                      />

                      <span>
                        {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RANGES.TEXT_3' | translate }}
                      </span>

                      <input
                        type="number"
                        required
                        [formControl]="range?.get('points')"
                        [value]="range?.get('points').value"
                        [ngClass]="{ 'error-border': hasError(range.get('points')) }"
                        class="h-36 mr-80 field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                        (input)="range.get('points').setValue($event.target.value)"
                      />

                      <span>
                        {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RANGES.TEXT_4' | translate }}
                      </span>

                      <input
                        type="number"
                        required
                        [formControl]="range?.get('discount')"
                        [value]="range?.get('discount').value"
                        [ngClass]="{ 'error-border': hasError(range.get('discount')) }"
                        class="h-36 field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                        (input)="range.get('discount').setValue($event.target.value)"
                      />

                      <span>
                        {{ 'DIALOG_EDIT_CRITERIAS_GROUP.RANGES.TEXT_5' | translate }}
                      </span>
                    </div>
                    <mat-icon
                      *ngIf="criteriaFormGroup.get('value').get('percentRange')?.controls?.length > 1"
                      [matTooltip]="'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.DELETE_CRITERIA_GROUP' | translate"
                      (click)="deleteRangeByIndex(criteriaFormGroup.get('value').get('percentRange'), j)"
                      class="field-dialog__footer__delete-button mr-12"
                    >
                      delete
                    </mat-icon>
                  </div>
                  <mat-error class="m-12 mt-0" *ngIf="range.getError('rangeConflict')">
                    {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.RANGE_CONFLICT' | translate }}
                  </mat-error>
                </div>
                <button
                  (click)="addPercentRange(criteriaFormGroup.get('value').get('percentRange'))"
                  *ngIf="true"
                  class="field-dialog__content__scroll__forms__criterias__criteria__content__range-input__input-group__add-button"
                >
                  Adicionar regra
                </button>
              </ng-container>

              <ng-container *ngIf="isMeanTime.includes(criteriaFormGroup.get('ruleName').value)">
                <div class="field-dialog__content__scroll__forms__criterias__criteria__content__input">
                  <span [innerHTML]="'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.MEAN_TIME.FIRST' | translate"></span>
                  <div class="input-block-with-validation">
                    <input
                      type="number"
                      [formControl]="criteriaFormGroup.get('value').get('resultThreshold')"
                      [value]="criteriaFormGroup.get('value').get('resultThreshold').value"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                    />
                    <mat-error *ngIf="criteriaFormGroup.get('value').get('resultThreshold').hasError('max')">
                      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.MAX_VALUE' | translate }}
                    </mat-error>
                  </div>
                  <span [innerHTML]="'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.MEAN_TIME.SECOND' | translate"></span>
                  <div class="input-block-with-validation">
                    <input
                      type="number"
                      [formControl]="criteriaFormGroup.get('value').get('points')"
                      [value]="criteriaFormGroup.get('value').get('points').value"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                    />
                    <mat-error *ngIf="criteriaFormGroup.get('value').get('points').hasError('max')">
                      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.MAX_VALUE' | translate }}
                    </mat-error>
                  </div>
                  <span>{{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.POINTS' | translate }}</span>
                </div>
              </ng-container>

              <ng-container *ngIf="criteriaFormGroup.get('ruleName').value === 'average_rating'">
                <div class="field-dialog__content__scroll__forms__criterias__criteria__content__input">
                  <span [innerHTML]="'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.AVERAGE_RATING.TEXT' | translate"></span>
                  <div class="input-block-with-validation">
                    <input
                      type="number"
                      [formControl]="criteriaFormGroup.get('value').get('points')"
                      [value]="criteriaFormGroup.get('value').get('points').value"
                      class="field-dialog__content__scroll__forms__criterias__criteria__content__input__points"
                    />
                    <mat-error *ngIf="criteriaFormGroup.get('value').get('points').hasError('max')">
                      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.ERRORS.MAX_VALUE' | translate }}
                    </mat-error>
                  </div>
                  <span>{{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.POINTS' | translate }}</span>
                </div>
                <span class="field-dialog__content__scroll__forms__criterias__criteria__content__description">
                  {{ 'DIALOG_EDIT_CRITERIAS_GROUP.POINT_INPUT.AVERAGE_RATING.DESCRIPTION' | translate }}
                </span>
              </ng-container>
            </div>
          </div>
          <button
            (click)="addCriteria()"
            *ngIf="criteriasGroupForm.get('criterias').controls.length < criteriaRules.length"
            class="field-dialog__content__scroll__forms__criterias__add-criteria-button"
          >
            {{ 'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.ADD_CRITERIA' | translate }}
          </button>
        </div>
      </div>
    </form>

    <ng-container *ngIf="isLoading">
      <div class="field-dialog__content__loading">
        <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
        <span>{{ 'COMPANY_RANKING.LOADING' | translate }}</span>
      </div>
    </ng-container>
  </div>

  <div class="field-dialog__footer">
    <button
      *ngIf="isOnEditDialog"
      [disabled]="criteriasGroupForm && criteriasGroupForm.invalid"
      (click)="applyCriterias()"
      class="field-dialog__footer__apply-button"
      mat-raised-button
    >
      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.APPLY' | translate }}
    </button>

    <button
      *ngIf="!isOnEditDialog"
      [disabled]="criteriasGroupForm && criteriasGroupForm.invalid"
      (click)="addCriteriasGroup()"
      class="field-dialog__footer__apply-button"
      mat-raised-button
    >
      {{ 'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.CREATE' | translate }}
    </button>

    <mat-icon
      *ngIf="isOnEditDialog && deletionShouldBeEnabled"
      [matTooltip]="'DIALOG_EDIT_CRITERIAS_GROUP.BUTTONS.DELETE_CRITERIA_GROUP' | translate"
      (click)="deleteCriteriaGroup()"
      class="field-dialog__footer__delete-button"
    >
      delete
    </mat-icon>
  </div>
</div>
